'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'

const HeaderUploadItemButton = (props: ComponentProps<typeof Button>) => {
  const { track } = useTracking()

  function handleClick() {
    track(clickEvent({ target: ClickableElement.UploadItem }))
  }

  return (
    <Button
      {...props}
      styling={Button.Styling.Filled}
      size={Button.Size.Small}
      rel="nofollow"
      onClick={handleClick}
    />
  )
}

export default HeaderUploadItemButton
